import { render, staticRenderFns } from "./BnetPendingAlert.vue?vue&type=template&id=2aebefb6&scoped=true&"
import script from "./BnetPendingAlert.vue?vue&type=script&lang=js&"
export * from "./BnetPendingAlert.vue?vue&type=script&lang=js&"
import style0 from "./BnetPendingAlert.vue?vue&type=style&index=0&id=2aebefb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aebefb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VList,VListItem,VListItemContent,VListItemIcon,VRow})
